// @flow

import { connect } from 'react-redux';
import type { State } from 'app/common/redux/reducers/types';

// Flow typing for the prop injected by this withViewer HOC
export type { Viewer } from 'app/packages/pinterest-flow-types/viewer';

const mapStateToProps = ({ viewer }: State) => ({ viewer });

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default connect(mapStateToProps);
